'use client';
import React from 'react';
import styles from './style.module.scss';

interface ModalProps {
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ children }) => {
  return <div className={styles.modalContainer}>{children}</div>;
};

export default Modal;
